<template>
    <div>
        <form @submit.prevent="submitPrevent" id="principal_invite_form" autocomplete="off"
              ref="principal_invite_form" class="content-inner formValidation">
            <div class="panel-sub-heading headingSmall">
                <span class="markedBottom">{{ lang('principal_invitation') }}</span>
            </div>
            <div v-for="(owner, index) in owners" class="row">
                <div class="col-12">
                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <i class="fa fa-user"></i><span>{{lang('principal') + ' ' + (index + 1)}}</span>
                            <a href="#" class="btn btn-warning float-right float-end btn-sm"
                               v-if="$parent.isPartnershipLLP && index > 1" @click="removePrincipal(index)">
                                <i class="fa fa-minus"></i></a>
                            <a href="#" class="btn btn-warning float-right float-end btn-sm"
                               v-else-if="!$parent.isPartnershipLLP && index > 0" @click="removePrincipal(index)">
                                <i class="fa fa-minus"></i></a>
                        </div>
                        <div class="card">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-md-6">
                                        <np-input
                                                :id="`owner_first_name_${index}`"
                                                :name="`owner_first_name[${index}]`"
                                                ref="owner_first_name"
                                                :label="lang('field_first_name')"
                                                :rules="['alpha_name']"
                                                :maxlength="getFirstNameMaxLengthByIso3('max')"
                                                :no-wrapper="false"
                                                v-model="owner.owner_first_name">
                                        </np-input>
                                        <np-input
                                                :id="`email_address_${index}`"
                                                :name="`email_address[${index}]`"
                                                ref="owner_email"
                                                :label="lang('field_email')"
                                                :rules="['valid_email']"
                                                :maxlength="50"
                                                :no-wrapper="false"
                                                v-model="owner.owner_email">
                                        </np-input>
                                    </div>
                                    <div class="col-md-6">
                                        <np-input
                                                :id="`owner_surname_${index}`"
                                                :name="`owner_surname[${index}]`"
                                                ref="owner_surname"
                                                :label="lang('owner_surname')"
                                                :rules="['alpha_name']"
                                                :maxlength="25"
                                                :no-wrapper="false"
                                                v-model="owner.owner_surname">
                                        </np-input>
                                        <div class="row compactInputFormat" ref="owner_phone">
                                            <div class="col-12 col-md-4">
                                                <label>{{lang('phone')}}</label>
                                            </div>
                                            <div class="col-12 col-md-2 col-4">
                                                <np-select2
                                                        :id="`owner_phone_code_${index}`"
                                                        :name="`owner_phone_code[${index}]`"
                                                        ref="owner_phone_code"
                                                        :no-wrapper="true"
                                                        :mode="`phone`"
                                                        :required="true"
                                                        :parameters="parameters.PHONE_CODES"
                                                        v-model="owner.owner_phone_code">
                                                </np-select2>
                                            </div>
                                            <div class="col-12 col-md-6 col-8">
                                                <np-phone
                                                        :id="`owner_phone_no_${index}`"
                                                        :name="`owner_phone_no[${index}]`"
                                                        ref="owner_phone_no"
                                                        :no-wrapper="true"
                                                        :label="lang('phone_number')"
                                                        :rules="['numeric', 'phone_no_leading_zero']"
                                                        :maxlength="10"
                                                        :phone-code="owner.owner_phone_code"
                                                        v-model="owner.owner_phone_no">
                                                </np-phone>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 ">
                                        <button v-if="owner.invite_status === '0'" @click="sendInvite(owner)"
                                                type="button" class="btn btn-default float-right float-end">{{lang('invite')}}
                                        </button>
                                        <button v-else-if="owner.invite_status === '1'" disabled="disabled"
                                                type="button" class="btn btn-success float-right float-end">{{lang('invited')}}
                                        </button>
                                    </div>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <div class="row">
                <div class="col-12">
                    <button type="button" class="btn btn-default btn-lg btn-block" @click="addPrincipal">
                        {{lang('add_principal')}}
                    </button>
                </div>
            </div>
        </form>

    </div>
</template>

<script>
    import {
        NPInput,
        NPModal, NPPhone,
        NPRadios, NPResponsive, NPSelect2,
    } from "netpify/components";
    import {Owner, OwnerInvite} from "../../../entities";
    import {mapState} from "pinia";
    import utilMixin from "../../../utils/mixins";

    export default {
        name: "invite",
        mixins:[utilMixin],
        components: {
            'np-select2': NPSelect2,
            'np-input': NPInput,
            'np-responsive': NPResponsive,
            'np-phone': NPPhone,
        },
        data() {
            return {

            }
        },
        created() {

        },
        computed: {
            ...mapState(useApplicationStore, {
                owners: function () {
                    return this.merchant.owners;
                },
                merchant: function (){
                    return this.merchant
                }
            }),
            parameters: function () {
                return this.$parent.parameters
            },
        },
        methods: {
            sendInvite: function (owner){
                ////console.log(owner);

                //TODO send invite ajax call.
                // update owner invite status.
                let url = '/application/ajaxinviteprincipal/' + this.merchant.merchant_data_id;
                this.getAxiosInstance().post(url, owner).then(response => {
                    if (response.data.result === 'SUCCESS') {
                        owner.invite_status = '1';
                        ////console.log(response.data);
                    }
                })
            },
        }
    }
</script>

<style scoped>

</style>
